module.exports = __webpack_public_path__ + "img/bg.8f7b4e61.png";